export { default as Oracle } from './Oracle';
export { default as Adobe } from './Adobe';
export { default as ActiveCampaign } from './ActiveCampaign';
export { default as AWS } from './AWS';
export { default as Salesforce } from './Salesforce';
export { default as SAP } from './SAP';
export { default as DynamicYield } from './DynamicYield';
export { default as GoogleAnalytics } from './GoogleAnalytics';
export { default as Segment } from './Segment';
export { default as Slack } from './Slack';
export { default as Zapier } from './Zapier';
export { default as Hubspot } from './Hubspot';
export { default as Heroku } from './Heroku';
export { default as NextJS } from './NextJS';
export { default as ReactJS } from './React';
export { default as Shopify } from './Shopify';
export { default as Vercel } from './Vercel';
export { default as Commercetools } from './Commercetools';
export { default as Postman } from './Postman';
export { default as ServiceNow } from './ServiceNow';
export { default as Atlassian } from './Atlassian';
